import { useState } from 'react';
import MarkdownText from './MarkdownText';
import SolutionCodeBlock from './SolutionCodeBlock';
import { officialSolutionVariants } from '../utils/baseProgRole';

/**
 * Кнопка «Показать решение / разбор» с вкладками вариантов эталонного кода.
 */
export default function OfficialSolutionsPanel({
  task,
  theme = 'dark',
  editorSettings,
  className = '',
}) {
  const [open, setOpen] = useState(false);
  const [activeIdx, setActiveIdx] = useState(0);
  const variants = officialSolutionVariants(task);
  const explanation = String(task?.solution_explanation ?? '').trim();

  if (!explanation && variants.length === 0) return null;

  const active = variants[activeIdx] || variants[0];

  return (
    <div className={`task-answer-solution ${className}`.trim()}>
      <div className="solution-block">
        <button
          type="button"
          className="btn btn-outline btn-sm"
          onClick={() => setOpen((prev) => !prev)}
        >
          {open ? 'Скрыть разбор' : 'Показать решение / разбор'}
        </button>
        {open && (
          <div className="solution-text">
            {explanation ? (
              <MarkdownText className="statement-text" text={explanation} />
            ) : null}
            {variants.length > 1 ? (
              <div className="solution-variants-tabs" role="tablist" aria-label="Варианты решения">
                {variants.map((v, i) => (
                  <button
                    key={`${v.label}-${i}`}
                    type="button"
                    role="tab"
                    aria-selected={i === activeIdx}
                    className={`btn btn-outline btn-xs solution-variant-tab ${i === activeIdx ? 'active' : ''}`}
                    onClick={() => setActiveIdx(i)}
                  >
                    {v.label}
                  </button>
                ))}
              </div>
            ) : null}
            {active?.code ? (
              <SolutionCodeBlock
                code={active.code}
                theme={theme}
                editorSettings={editorSettings}
              />
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
}
